import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class DimeloService {

  environment = environment;
  constructor(private apiService: ApiService) {}

  /**
   * Get token
   */
  get(): Observable<{ token: string }> {
    return this.apiService.get('dimelo/token');
  }
}
